export const useStyles = theme => ({
  root: {
    height: '100%',
    [theme.breakpoints.between('xs', 'md')]: {
      //padding: '0',
    },
  },
  nameContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  index: {
    fontSize: '2rem',
    font: 'normal normal 20px/36px Maax-Bold',
    fontWeight: 600,
    color: '#a6a6a6',
    display: 'block',
    padding: '10px 5px 5px 5px',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      fontSize: '2rem',
    },
  },
  placeCol: {
    position: 'relative',
    width: '10%',
    textAlign: 'center',
    fontFamily: 'Maax-Bold',
  },
  nameCol: {
    position: 'relative',
    width: '70%',
    fontFamily: 'Maax-Bold',
  },
  pointsCol: {
    position: 'relative',
    width: '10%',
    textAlign: 'center',
    fontFamily: 'Maax-Bold',
  },
  searchDiv: {
    position: 'absolute',
    right: '10px',
    cursor: 'pointer',
    color: 'gray',
  },
  tbody: {/*
    '& tr:nth-child( odd )': {},
  */},
  leaderBoardTable: {
    border: '0.5px solid',
    borderCollapse: 'collapse',
    margin: '0',
    padding: '0',
    width: '100%',
    tableLayout: 'auto',
    '& tr': {
      border: '1px solid #a6a6a6',
      padding: '.35em',
      textAlign: 'left',
    },
    '& th': {
      padding: '10px',
      fontSize: '1.2em',
      fontWeight: 600,
      background: '#d9d9d9',
      [theme.breakpoints.down('sm')]: {
        fontSize: '1em',
      },
    },
    '& td': {
      padding: '0 0.625em 0 0.625em',
    },
    /*[theme.breakpoints.between('xs', 'sm')]: {
      border: '0',
      '& tr': {
        //borderBottom: '3px solid #ddd',
        display: 'block',
        //marginBottom: '.625em',
        padding: 'unset',
      },
      '& td': {
        display: 'table-cell',
        textAlign: 'left',
      },
      '& td::before': {
        fontWeight: 'bold',
        textTransform: 'uppercase',
      },
      '& td:last-child': {
        borderBottom: '0',
      },
    },*/
  },
  nameTr: {
    //display: 'flex',
    alignItems: 'center',
    width: '80%',
    //position: 'relative',
  },
  placeTr: {
    textAlign: 'center',
  },
  guestDetails: {
    fontSize: '1.3rem',
    fontFamily: 'Maax',
    padding: '0.5em 0 0.5em 0',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.1rem',
    },
  },
  pagination: {
    justifyContent: 'center',
    paddingBottom: '20px',
  },
});
